export default __webpack_public_path__ + "44fbbf12e55c731ede96693b2aeb4afd.png";